import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

export const StatisticsSquareMidle = ({ icon, count, text }) => {
  const { t } = useTranslation();

  return (
    <div className="statistics-square-midle">
      <div className="block-square-icon">
        <div className="square-icon">
          <img src={icon} alt="icon" />
        </div>
      </div>

      <div className="statistics-square-count">
        <span className="number">{count}</span>
      </div>

      <p className="statistics-square-text">{t(text)}</p>
    </div>
  );
};
